<template>
  <div>
    <div class="sheet-panel sloan-descriptions" v-if="personality.psiccCode">
      <div class="sheet-header">
        <h3>Persona descriptions</h3>
        <button
          class="info-tip"
          title="Descriptions below fit your profile. Please highlight the words that you think your friends would use to describe you."
          v-tippy="{ theme: 'navy' }"
        >
          <font-awesome-icon icon="info" />
        </button>
      </div>
      <div class="sheet-content">
        <h5>Friends would describe me as..</h5>
        <span
          class="pill-career description"
          :class="{ match: item.status, neutral: !item.status }"
          @click="togglePsiccDescription(item)"
          v-bind:key="item.name"
          v-for="item in toggledPsiccs"
        >
          {{ item.name }} <font-awesome-icon icon="plus" />
          <font-awesome-icon icon="check" />
        </span>
        <hr v-if="toggledPsiccs.length" />
        <span
          class="pill-career description"
          :class="{ match: item.status, neutral: !item.status }"
          @click="togglePsiccDescription(item)"
          v-bind:key="item.name"
          v-for="item in neutralPsiccs"
        >
          {{ item.name }} <font-awesome-icon icon="plus" />
          <font-awesome-icon icon="check" />
        </span>
        <div v-if="isMoreDescriptionsToShow">
          <hr />
          <button
            @click="descriptionLimit = descriptionLimit + increaseLimit"
            class="load-more"
          >
            <font-awesome-icon icon="plus" /> Show more
          </button>
        </div>
        <div class="save-container" :class="{ toggled: modifiedPsiccs }">
          <button
            class="btn btn-primary btn-loader"
            :class="{ active: loading, success: success }"
            @click="savePsiccDescriptions"
          >
            <span>Save changes</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../main.js";

import { psiccCode } from "@/assets/psicc.js";
import { psiccSupport } from "@/assets/psicc.js";

var _ = require("lodash");
export default {
  computed: {
    toggledPsiccs() {
      return _.filter(this.transformedPsiccDescriptions, { status: true });
    },
    neutralPsiccs() {
      return _.filter(this.transformedPsiccDescriptions, {
        status: false,
      }).slice(0, this.descriptionLimit);
    },
    isMoreDescriptionsToShow() {
      if (
        _.filter(this.transformedPsiccDescriptions, { status: false }).length >=
        this.descriptionLimit
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  props: {
    personality: Object,
    psiccDescriptions: Array,
  },
  mounted() {
    this.transformPsiccDescriptions();
    if (this.$isMobile()) {
      this.descriptionLimit = 15;
      this.increaseLimit = 10;
    }
  },
  data() {
    return {
      loading: false,
      success: false,
      limited: true,
      descriptionLimit: 30,
      increaseLimit: 30,
      psiccCode: psiccCode,
      transformedPsiccDescriptions: null,
      modifiedPsiccs: false,
    };
  },
  methods: {
    transformPsiccDescriptions() {
      function removeDuplicates(array) {
        return [...new Set(array)];
      }

      let userPsiccDescriptions = [];

      if (this.psiccDescriptions && this.personality.psiccCode) {
        userPsiccDescriptions = this.psiccDescriptions;
      }

      let basePsiccDescriptions = this.psiccCode[this.personality.psiccCode]
        .descriptions;

      basePsiccDescriptions = basePsiccDescriptions.concat(
        psiccSupport.ope[this.personality.psiccSupport[0]]
      );
      basePsiccDescriptions = basePsiccDescriptions.concat(
        psiccSupport.con[this.personality.psiccSupport[1]]
      );
      basePsiccDescriptions = basePsiccDescriptions.concat(
        psiccSupport.ext[this.personality.psiccSupport[2]]
      );
      basePsiccDescriptions = basePsiccDescriptions.concat(
        psiccSupport.agr[this.personality.psiccSupport[3]]
      );
      basePsiccDescriptions = basePsiccDescriptions.concat(
        psiccSupport.neu[this.personality.psiccSupport[4]]
      );

      this.$shuffleArray(basePsiccDescriptions);

      basePsiccDescriptions = removeDuplicates(basePsiccDescriptions);

      let psiccObjectArray = [];

      basePsiccDescriptions.forEach((element) => {
        if (userPsiccDescriptions.includes(element)) {
          psiccObjectArray.push({ name: element, status: true });
        } else {
          psiccObjectArray.push({ name: element, status: false });
        }
      });
      this.transformedPsiccDescriptions = psiccObjectArray;
    },
    togglePsiccDescription(item) {
      this.modifiedPsiccs = true;
      this.transformedPsiccDescriptions.forEach((element) => {
        if (element.name == item.name) {
          if (element.status === true) {
            element.status = false;
          } else {
            element.status = true;
          }
        }
      });
    },
    savePsiccDescriptions() {
      let psiccArray = [];
      let user = firebase.auth().currentUser;
      let uid = user.uid;

      this.transformedPsiccDescriptions.forEach((element) => {
        if (element.status == true) {
          psiccArray.push(element.name);
        }
      });

      const data = { psiccDescriptions: psiccArray };

      if (uid) {
        this.loading = true;
        db.collection("users")
          .doc(uid)
          .update(data)
          .then(() => {
            this.loading = false;
            this.success = true;
            setTimeout(() => {
              this.success = false;
              this.modifiedPsiccs = false;
            }, 500);
          })
          .catch((err) => {
            this.$toast.open({
              message: err.message,
            });
            this.loading = false;
          });
      }
    },
  },
};
</script>
